export const MuiDialog = {
  styleOverrides: {
    root: {
      '& .MuiDialog-paper': {
        borderRadius: '24px',
      },
      '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
      },
    },
  },
};
